// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { orderStatusAddressDetailsStyles } from "@insite/content-library/Widgets/OrderStatus/OrderStatusAddressDetails";
import { addressOverviewStyles } from "@werner/App/Components/Common/AddressOverview";
import { xScreen } from "@werner/XDL/Utilities";
import { css } from "styled-components";

orderStatusAddressDetailsStyles.wrapper = {
    css: css`
        display: flex;
        ${xScreen("lte", "md")} {
            flex-direction: column;
            gap: 8px;
        }
    `,
};

orderStatusAddressDetailsStyles.titleText = {
    ...addressOverviewStyles.titleText,
};

orderStatusAddressDetailsStyles.shippingAddressWrapper = orderStatusAddressDetailsStyles.billingAddressWrapper = {
    ...addressOverviewStyles.wrapper,
    css: css`
        flex: 1;
        margin-bottom: 16px;
    `,
};
